var map = {
	"./chevron-left.svg": 649,
	"./chevron-right.svg": 650,
	"./facebook.svg": 651,
	"./instagram.svg": 652,
	"./loading.svg": 653,
	"./mastercard.svg": 654,
	"./menu.svg": 655,
	"./spinner.svg": 656,
	"./strava.svg": 657,
	"./trash.svg": 658,
	"./upload.svg": 659,
	"./visa.svg": 660,
	"./xlsx-file.svg": 661,
	"./youtube.svg": 662
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1261;



//////////////////
// WEBPACK FOOTER
// ./src/images/icons ^\.\/.*\.svg$
// module id = 1261
// module chunks = 0